/**
 * Google Tag Manager utility
 * Only initializes GTM in production environment
 */

interface GTMConfig {
  id: string;
}

export function initializeGTM(config: GTMConfig): void {
  if (import.meta.env.VITE_APP_ENV !== 'production') {
    return;
  }

  // Check if GTM is already initialized
  if (window.dataLayer) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  // GTM initialization function
  (function(w: Window, d: Document, s: string, l: string, i: string) {
    (w as any)[l] = (w as any)[l] || [];
    (w as any)[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s) as HTMLScriptElement,
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode?.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', config.id);
}

// Type declaration for window.dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
}
